import * as React from "react"
import { RouteComponentProps } from "react-router"
import CompanyInformation from "./CompanyInformation"

export default class MyOrganization extends React.Component<RouteComponentProps> {
  render() {
    return <CompanyInformation {...this.props} portalMode />
  }
}
